import React, { useState, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import ContinueCancelButtons from 'shared/components/ContinueCancelButtons'
import BackAnchor from 'shared/components/BackAnchor'
import { listAddAction, listEditAction } from 'redux/actions'

import DebtInformationForm from './forms/DebtInformationForm'

const DebtInformationView = ({ t, i18n, setIsError }) => {
  const history = useHistory()
  const dispatch = useDispatch()

  const editDebtInfoId = useSelector((state) => state.app.editDebtInfoId)
  const isSummary = useMemo(() => {
    return JSON.parse(new URLSearchParams(history.location.search).get('isSummary') ?? false)
  }, [history])

  const [validateForm, setValidateForm] = useState()

  const onNext = () => {
    try {
      const newDebtInfo = validateForm()
      if (newDebtInfo) {
        if (editDebtInfoId) {
          dispatch(listEditAction('debtInfo', newDebtInfo))
        } else {
          dispatch(listAddAction('debtInfo', newDebtInfo))
        }

        if (isSummary) {
          history.push(`/${i18n.language}${t('routes.review_summary')}`)
        } else {
          // history.push(`/${i18n.language}${t('routes.debt_info_list')}`)
          history.push(`/${i18n.language}${t('routes.contact_information')}`)
        }
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const addAnotherDebt = () => {
    try {
      const newDebtInfo = validateForm()
      if (newDebtInfo) {
        if (editDebtInfoId) {
          dispatch(listEditAction('debtInfo', newDebtInfo))
        } else {
          dispatch(listAddAction('debtInfo', newDebtInfo))
        }
        localStorage.setItem('addAnotherDebtClicked', 'debtPayment')
        history.push(`/${i18n.language}${t('routes.vehicle_tax_debt')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  return (
    <div className="container">
      <BackAnchor />
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h1>{t('debt_info.title')}</h1>
        </div>
      </div>
      <DebtInformationForm editDebtInfoId={editDebtInfoId} setValidateForm={setValidateForm} setIsError={setIsError} />
      <div className="col-xs-12 col-md-8">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <ContinueCancelButtons continueClick={onNext} showCancel={false} />
          <button className="add-debt-button" onClick={() => addAnotherDebt()} style={{ marginLeft: '30px' }}>
            {t('debt_info.add_another_debt')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(DebtInformationView)
